module.exports = __webpack_public_path__ + "media/images/help/company/mv-company-04-71ddd9fa10df30c121054f9463f68c51.jpg";